<div class="layout-topbar">
  <div class="topbar-start">
    <button
      #menubutton
      type="button"
      class="topbar-menubutton p-link p-trigger"
      (click)="onMenuButtonClick()"
    >
      <i class="pi pi-bars"></i>
    </button>
    <nav app-breadcrumb class="topbar-breadcrumb"></nav>
  </div>

  <div class="topbar-end">
    <ul class="topbar-menu">
      <li class="ml-3 mt-2">
        <button type="button" (click)="toggleDarkMode()">
          <i
            [ngClass]="{
              'pi !text-xl': true,
              'pi-moon': layoutService.isDarkTheme(),
              'pi-sun': !layoutService.isDarkTheme()
            }"
          ></i>
        </button>
      </li>
      <li class="topbar-profile">
        @if (user(); as user) {
        <p-overlaybadge
          [value]="notificationCount()"
          severity="danger"
          [badgeDisabled]="!notificationCount()"
        >
          <button
            type="button"
            class="p-link"
            aria-haspopup="menu"
            [attr.aria-label]="profileMenuLabel()"
            [attr.aria-expanded]="menuVisible"
            (keydown.enter)="profileMenu.toggle($event)"
            (keydown.space)="profileMenu.toggle($event)"
            (click)="profileMenu.toggle($event)"
          >
            @if (user.pictureUrl) {
            <p-avatar size="large" shape="circle" [image]="user.pictureUrl" />
            } @else {
            <p-avatar [label]="userInitials()" size="large" shape="circle" />
            }
          </button>
        </p-overlaybadge>
        } @else if (loginResolved && !isLoggedIn) {
        <button
          class="p-button-outlined p-button-sm"
          (click)="onLoginButtonClick()"
        >
          Login
        </button>
        } @else {
        <p-skeleton
          width="2rem"
          height="32px"
          shape="rectangle"
          class="p-mr-2"
        ></p-skeleton>
        }
      </li>
    </ul>
    <p-menu #profileMenu [model]="profileMenuItems()" [popup]="true" />
  </div>
</div>
